export const TAG_COLORS = [
    {
        tag: "New",
        color: "#5C6BC0",
    },
    {
        tag: "Regular",
        color: "#469D4A",
    },
    {
        tag: "Loyal",
        color: "#1E90FF",
    },
    {
        tag: "VIP",
        color: "#ECC142",
    },
    {
        tag: "Complex",
        color: "#CF5034",
    },
];
